import { forwardRef as s } from "react";
import { Box as i } from "theme-ui";
import "@material-bank/ds-utils";
import { Text as f } from "../Typography/Text.js";
import { jsx as r, jsxs as n, Fragment as l } from "theme-ui/jsx-runtime";
import { SeparatorHr as t } from "./SeparatorHr/SeparatorHr.js";
const c = s((p, a) => {
  const {
    text: x,
    textSx: m,
    sx: o,
    ...e
  } = p;
  return x ? /* @__PURE__ */ n(l, {
    children: [/* @__PURE__ */ r(i, {
      sx: {
        flexShrink: 1,
        flexGrow: 1
      },
      children: /* @__PURE__ */ r(t, {
        ...e,
        sx: o
      })
    }), /* @__PURE__ */ r(f, {
      sx: {
        px: 4,
        color: "secondaryText",
        ...m
      },
      children: x
    }), /* @__PURE__ */ r(i, {
      sx: {
        flexShrink: 1,
        flexGrow: 1
      },
      children: /* @__PURE__ */ r(t, {
        ...e,
        sx: o
      })
    })]
  }) : /* @__PURE__ */ r(t, {
    ref: a,
    ...e,
    sx: o
  });
});
c.displayName = "Separator";
export {
  c as Separator
};
